/* ==========================================================================
   TUCANO · Zaino Ombrello — pioggia animata (canvas)
   Inizializza un canvas [data-zo-rain] con gocce verticali in caduta.
   Riusato da più sezioni della landing (hero + sezione full-bleed).
   ========================================================================== */

(() => {
  'use strict';

  function initRainCanvas(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let width = 0;
    let height = 0;
    let drops = [];
    let raf = null;

    const density = parseFloat(canvas.dataset.zoRainDensity || '0.00012');

    function resize() {
      const rect = canvas.parentElement.getBoundingClientRect();
      width = canvas.width = rect.width * window.devicePixelRatio;
      height = canvas.height = rect.height * window.devicePixelRatio;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      const count = Math.max(30, Math.round(width * height * density));
      drops = new Array(count).fill(0).map(() => makeDrop());
    }

    function makeDrop() {
      return {
        x: Math.random() * width,
        y: Math.random() * height,
        len: (14 + Math.random() * 22) * window.devicePixelRatio,
        speed: (6 + Math.random() * 8) * window.devicePixelRatio,
        drift: (-0.6 + Math.random() * 1.2) * window.devicePixelRatio,
        opacity: 0.08 + Math.random() * 0.22,
      };
    }

    function tick() {
      ctx.clearRect(0, 0, width, height);
      ctx.lineCap = 'round';
      drops.forEach((d) => {
        ctx.strokeStyle = `rgba(243,241,236,${d.opacity})`;
        ctx.lineWidth = window.devicePixelRatio;
        ctx.beginPath();
        ctx.moveTo(d.x, d.y);
        ctx.lineTo(d.x + d.drift * 3, d.y + d.len);
        ctx.stroke();

        d.y += d.speed;
        d.x += d.drift;
        if (d.y > height) {
          d.y = -d.len;
          d.x = Math.random() * width;
        }
      });
      raf = requestAnimationFrame(tick);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!raf) tick();
        } else if (raf) {
          cancelAnimationFrame(raf);
          raf = null;
        }
      });
    }, { threshold: 0.05 });

    resize();
    io.observe(canvas);
    window.addEventListener('resize', resize);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas.style.display = 'none';
    }
  }

  function init() {
    document.querySelectorAll('[data-zo-rain]').forEach(initRainCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
